<script>
    import Router from "svelte-spa-router";
    import routes from "./routes";
    import { hostname, environment, theme, version, site } from "./stores.js";
    import { SvelteToast } from "@zerodevx/svelte-toast";
    import Downloader from "./components/Downloader.svelte";
    import { downloader } from "./downloadstores.js";
    import PipelineObserver from "./components/PipelineObserver.svelte";
    import { pipelineObserver } from "./pipelinestores.js";
    import { onMount } from "svelte";

    export let buildVersion;
    export let env;

    // For normal Svelte dev flow, e.g. npm run dev, use an existing backend
    if (window.location.toString().startsWith("http://localhost:5050")) {
        $hostname = "https://zealous-smoke-0ff875103-dev.westeurope.azurestaticapps.net";
    }

    if (window.location.toString().includes("cloud") || window.location.toString().includes("happy-rock")) {
        $site = "ExternalWebFrontend";
        const favicon = document.getElementById("favicon");
        favicon.href = "/favicon-ext.png";
    } else {
        $site = "WebFrontend";
    }

    $environment = env;

    if ($theme === "dark") {
        window.document.body.classList.add("dark");
    } else if ($theme === "light") {
        window.document.body.classList.remove("dark");
    }

    const toastOptions = {
        initial: 0,
        next: 0,
        dismissable: true,
    };

    console.log("1234567898765434567 VERSION: ", buildVersion);
    $version = buildVersion;

    //////////////// DOWNLOADING AND OBSERVING ///////////////////////
    // Will be initialised by creation of <Downloader>
    let dlc;
    let plo;
    onMount(() => {
        // Make sure components are mounted before we initialise the 'singleton' downloader
        $downloader = dlc.getDownloaderComponent();

        // Make sure components are mounted before we initialise the 'singleton' pipelineobserver
        $pipelineObserver =  plo.getPipelineObserverComponent();

        const failedHandler = (e) => {
            console.log('APP NOTICED THAT SOMETHING FAILED!', e);
        };
        const doneHandler = (e) => {
            console.log('APP NOTICED THAT SOMETHING DONE!', e);
        };
        $pipelineObserver.events.addEventListener("pipelinesfailed", failedHandler);
        $pipelineObserver.events.addEventListener("pipelinesdone", doneHandler);

        // onDestroy:
        return () => {
            $pipelineObserver.events.removeEventListener("pipelinesfailed", failedHandler);
            $pipelineObserver.events.removeEventListener("pipelinesdone", doneHandler);
        };
    });
    ///////////// END DOWNLOADING AND OBSERVING //////////////////////

    // Highlight.io instrumentation
    /*if ($environment == "prod" || $environment == "dev") {
        H.init('ve6zo3dp', {
            environment: $environment || 'dev',
            version: commitHash,
            networkRecording: {
                enabled: true,
                recordHeadersAndBody: true,
                urlBlocklist: [
                    // insert urls you don't want to record here
                    "ingest.sentry.io"
                ],
            },
        });
    }*/
</script>

<main>
    <Router {routes} />
    <SvelteToast options={toastOptions} />
    <Downloader bind:this={dlc} />
    <PipelineObserver bind:this={plo} />
</main>

<style>
    main {
        text-align: center;
        padding: 0;
        margin: 0 auto;
        min-height: 100%;
    }

    /** BEGIN Application-global elements */
    :global(body) {
        --var-theme-base-background-color: white;
        --var-theme-base-color: #333;
        --var-theme-background-color: #242d32;
        --var-theme-color: whitesmoke;
        --var-theme-disabled-background-color: #ddd;
        --var-theme-disabled-color: whitesmoke;
        --var-theme-secondary-background-color: lightgrey;
        --var-theme-secondary-color: grey;
        --var-theme-tertiary-background-color: transparent;
        --var-theme-tertiary-color: grey;
        --var-theme-hover-background-color: #0080e1;
        --var-theme-hover-color: whitesmoke;
        --var-theme-mouseover-background-color: #f4f4f4;
        --var-theme-mouseover-color: #555;
        background-color: var(--var-theme-base-background-color);
        color: var(--var-theme-base-color);
    }

    :global(body.dark) {
        --var-theme-base-background-color: #222;
        --var-theme-base-color: whitesmoke;
        --var-theme-background-color: #ccc;
        --var-theme-color: #333;
        --var-theme-disabled-background-color: #777;
        --var-theme-disabled-color: #333;
        --var-theme-secondary-background-color: #555;
        --var-theme-secondary-color: grey;
        --var-theme-tertiary-background-color: transparent;
        --var-theme-tertiary-color: grey;
        --var-theme-hover-background-color: #0080e1;
        --var-theme-hover-color: whitesmoke;
        --var-theme-mouseover-background-color: #f4f4f4;
        --var-theme-mouseover-color: #555;
        background-color: var(--var-theme-base-background-color);
        color: var(--var-theme-base-color);
    }

    :global(button) {
        color: var(--var-theme-color);
        background-color: var(--var-theme-background-color);
        outline: none;
        border-radius: 6px;
        border: none;
        flex-shrink: 2;
        padding: 8px 16px 8px 16px;
    }
    :global(body.dark button) {
        background-color: var(--var-theme-background-color);
        color: var(--var-theme-color);
    }

    :global(button:hover) {
        color: var(--var-theme-hover-color);
        background-color: var(--var-theme-hover-background-color);
    }
    :global(body.dark button:hover) {
        color: var(--var-theme-hover-color);
        background-color: var(--var-theme-hover-background-color);
    }

    :global(button.disabled) {
        background-color: var(--var-theme-disabled-background-color);
        color: var(--var-theme-disabled-color);
        cursor: not-allowed;
    }

    :global(body.dark button.disabled) {
        background-color: var(--var-theme-disabled-background-color);
        color: var(--var-theme-disabled-color);
        cursor: not-allowed;
    }

    :global(button.active) {
        box-shadow: 0 0 7px var(--var-theme-background-color);
    }

    :global(body.dark button.active) {
        box-shadow: 0 0 7px var(--var-theme-background-color);
    }

    :global(button.tertiary) {
        background-color: var(--var-theme-tertiary-background-color);
        color: var(--var-theme-tertiary-color);
    }

    :global(button.tertiary:hover) {
        background-color: var(--var-theme-tertiary-background-color);
        color: var(--var-theme-hover-background-color);
    }

    :global(button.experimental) {
        background-color: var(--var-theme-secondary-background-color);
        color: var(--var-theme-secondary-color);
    }

    :global(body.dark button.experimental) {
        background-color: var(--var-theme-secondary-background-color);
        color: var(--var-theme-secondary-color);
    }

    :global(button.experimental:hover) {
        color: var(--var-theme-hover-color);
        background-color: var(--var-theme-hover-background-color);
    }

    :global(button.error) {
        color: white;
        background-color: red;
    }


    :global(button.error:hover){
        background-color: var(--var-theme-hover-background-color);
    }

    :global(body.dark button.experimental:hover) {
        color: var(--var-theme-hover-color);
        background-color: var(--var-theme-hover-background-color);
    }


    :global(.icon-and-text-button svg) {
        vertical-align: text-bottom;
        margin-right: 8px;
        margin-top: -4px;
        margin-bottom: -2px;
    }

    :global(input) {
        background-color: var(--var-theme-base-background-color);
        color: var(--var-theme-base-color);
    }

    :global(table) {
        margin: auto 0;
        border-collapse: collapse;
        border-spacing: 0px;
        box-sizing: border-box;
        padding: auto;
    }
    :global(tr:hover td) {
        background-color: var(--var-theme-mouseover-background-color);
        color: var(--var-theme-mouseover-color);
    }

    :global(tfoot > tr:hover td) {
        background-color: transparent;
    }

    :global(tfoot > tr td) {
        border: 1px solid red;
    }

    :global(th, td) {
        border: 1px solid var(--var-theme-base-color);
        border-collapse: collapse;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 6px 8px;
        /* min-width: 8em; */
    }

    :global(body.dark th) {
        border: 1px solid var(--var-theme-background-color);
    }

    :global(.tv) {
        border: 1px solid var(--var-theme-background-color);
        border-collapse: collapse;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 6px 8px;
        min-width: 8em;
    }

    :global(.tv div) {
        display: flex;
        padding: 0;
        margin: 0;
        border: none;
        background: none;
    }

    :global(body.dark a) {
        color: #0080e1;
    }

    :global(body.dark a:hover) {
        color: #0080e1;
    }
    :global(body.dark a:visited) {
        color: #2080e1;
    }

    :global(annotation) {
        margin-left: 8px;
        padding-left: 0;
        padding-right: 0;
        font-size: small;
        color: var(--var-theme-secondary-color);
    }

    :global(refresh-button) {
        background-color: transparent;
        color: var(--var-theme-base-color);
        vertical-align: text-bottom;
        display: inline-flex;
    }

    :global(refresh-button:hover) {
        cursor: pointer;
        color: var(--var-theme-hover-background-color);
    }

    :global(refresh-button.rotate) {
        animation: rotation 2s infinite linear;
    }

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(359deg);
        }
    }

    /** END Application-global elements */

    @media (min-width: 640px) {
        main {
            max-width: none;
        }
    }

    :global(._toastItem) {
        text-align: left;
    }

    :global(._toastMsg) {
        overflow-wrap: anywhere;
    }
</style>
